import React from 'react';
import maintenanceImage from '../assets/images/Maintenance/maintenance.png'

export default function Maintenance() {
    return (
        <div>
            <div style={{ position: 'relative', zIndex: 1, padding: '0px 18px' }}>
                <h2>Sorry for the inconvenience. Please try again later</h2>
            </div>
            <div style={{ position: 'absolute', top: 0, width: '100vw', height: '99%' }}>
                <img src={maintenanceImage} alt='under maintenance' width='100%' height='100%' />
            </div>
        </div>
    )
}
